<template>
  <div class="drawer" v-if="curUser">

    <div class="user-avatar">
      <!--      <div class="avatar"></div>-->
      <div v-if="curUser" class="avatar-details">
        <h5>{{ curUser.Username }}</h5>
<!--        <h6>{{ curUser.Username }}</h6>-->
      </div>
    </div>

    <div class="accordion-item" style="cursor: pointer" v-if="isUpdateAvailable">
      <a @click="updateApp">
        <div class="d-flex flex-column text-center my-2">
          <font-awesome-icon class="icon text-info" icon="Ffa-solid fa-exclamation-circle"/>
          Update Is Available
          <span class="text-sm" @click="updateApp">Click to Update</span>
        </div>
      </a>
    </div>

    <div class="routes">
      <ul>
        <li >
          <router-link @click.native="back" :to="{ name : 'subs' }">
            <div class="icon-box">
              <font-awesome-icon class="icon" icon="chart-line"/>
            </div>
            Subscriptions
          </router-link>
        </li>

        <li >
          <router-link @click.native="back" :to="{ name : 'customer' }">
            <div class="icon-box">
              <font-awesome-icon class="icon" icon="fa-solid fa-users"/>
            </div>
            All Customers
          </router-link>
        </li>

        <li >
          <router-link @click.native="back" :to="{ name : 'inactive' }">
            <div class="icon-box">
              <font-awesome-icon class="icon" icon="exclamation-circle"/>
            </div>
            Inactive Accounts
          </router-link>
        </li>

        <li >
          <router-link @click.native="back" :to="{ name : 'create-ticket' }">
            <div class="icon-box">
              <font-awesome-icon class="icon" icon="fa-solid fa-print"/>
            </div>
            Create Ticket
          </router-link>
        </li>

        <li >
          <router-link @click.native="back" :to="{ name : 'tickets' }">
            <div class="icon-box">
              <font-awesome-icon class="icon" icon="fa-solid fa-print"/>
            </div>
            Ticket Search
          </router-link>
        </li>

        <li >
          <router-link @click.native="back" :to="{ name : 'kazang-smart-invoice' }">
            <div class="icon-box">
              <font-awesome-icon class="icon" icon="plus"/>
            </div>
            Smart Invoicing
          </router-link>
        </li>

        <li>
          <router-link @click.native="back" :to="{ name : 'kdiy-stores' }">
            <div class="icon-box">
              <font-awesome-icon class="icon" :icon="['fas', 'store']"/>
            </div>
            KDIY
          </router-link>
        </li>

        <li>
          <router-link @click.native="back" :to="{ name : 'kpc-requests' }">
            <div class="icon-box">
              <font-awesome-icon class="icon" icon="fa-solid fa-file-invoice-dollar"/>
            </div>
            K-Petty Cash
          </router-link>
        </li>

        <!-- k-petty-cash items removed from feature/pos-signup-approval -->

        
        <li v-if="curUser.id === 129">
          <router-link @click.native="back" :to="{ name : 'view-users' }">
            <div class="icon-box">
              <font-awesome-icon class="icon" icon="fa-solid fa-address-card"/>
            </div>
            User management
          </router-link>
        </li>

        <li>
          <a href="#" @click.prevent="logout">
            <div class="icon-box">
              <font-awesome-icon class="icon" icon="fa-solid fa-arrow-right-from-bracket"/>
            </div>
            Log Out
          </a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { Storage } from '@/Services/Storage';
import { mapActions } from "vuex";
export default {
  name: "NavigationDrawer",
  props: {
    close: {
      type: Function,
      required: true,
    }
  },
  computed: {
    curUser() {
      let user = JSON.parse(localStorage.getItem("current_store"));
      console.log(user);
      if (user) return user;
      return {
        Username: 'Null',
        Type: 'Unknown',
      };
    },
    isUpdateAvailable() {
      return this.$store.getters.getUpdateAvailability;
    },
  },
  methods: {
    updateApp() {
      this.$store.commit(`setUpdateAvailability`, false);
      return window.location.reload(true);
    },
    back() {
      if (this.close) {
        this.close();
      } else {
        console.log("Close not defined");
      }
    },
    async logout() {
      try {
        if (window.usageTracker && window.usageTracker.flush) {
          window.usageTracker.flush();
        }
        localStorage.removeItem("current_store");
        await this.$router.push('/')
      } catch (err){
        await Swal.fire("Error", "Something went wrong", "error")
      }
    },
  },
}
</script>


<style lang="scss" scoped>
a {
  &:hover, &.a-exact-active {
    background: #f1f1f1;
    color: #3F8DCD;

    .icon {
      color: #3F8DCD;
    }
  }
}

.disabled {
  pointer-events: none;
  display: none;
}

.drawer {
  width: 100%;
  background: white;
  height: 100%;
  overflow-y: auto;

  .routes {
    ul {
      list-style: none;
      margin: 0;
      padding: 0;

      li {
        padding: 0;

        a {
          height: 50px;
          display: flex;
          flex-direction: row;
          align-items: center;
          font-weight: 600;
          padding-left: 10px;
          text-decoration: none;
          color: #1c1c1c;

          .icon-box {
            width: 35px;
            margin-right: 10px;
            display: flex;
            justify-content: center;

            .icon {
              font-size: 25px;
              color: #34373C;
            }
          }

          &:hover, &.router-link-exact-active {
            background: #f1f1f1;
            color: #3F8DCD;
            font-weight: 700;

            .icon-box {
              .icon {
                color: #3F8DCD;
              }
            }
          }
        }
      }
    }
  }

  .user-avatar {
    display: inline-flex;
    width: 100%;
    background: url('/src/assets/img/KazangBanner.png') fixed;
    background-size: cover;
    color: white;
    min-height: 140px;
    background-color: rgba(50, 70, 80, 0.7);
    background-blend-mode: soft-light;

    .avatar {
      background: #40434A;
      min-width: 80px;
      width: 80px;
      height: 80px;
      border-radius: 50%;
    }

    .avatar-details {
      width: 100%;
      padding: 5px 5px 5px 10px;
      display: flex;
      flex-direction: column;
      align-items: start;
      justify-content: center;

      h5, p {
        margin: 0;
      }

      p {
        font-size: 15px;
        color: #ffffff;
        font-weight: 400;

        &:nth-child(3) {
          color: #15356E;
          font-weight: 600;
        }
      }

    }
  }
}

ul {
  text-align: center;

  span {
    font-family: "Inter", sans-serif;
    font-size: 15px;
    font-weight: bold;
  }
}

.last-upd {
  font-weight: bold;
}


.menu {
  text-align: center;

  span {
    font-family: "Inter", sans-serif;
    font-size: 15px;
    font-weight: bold;
  }
}

.last-upd {
  font-weight: bold;
}

.icon {
  margin-right: 10px;
  color: #606d77;
  font-size: 1.5rem;
}

.route-btn {
  height: 50px;
  display: flex;
  flex-direction: row;
  align-items: center;
  font-weight: 600;
  padding-left: 10px;
  text-decoration: none;
  color: #1c1c1c;
}

</style>
